"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evenHex = exports.prepend0x = exports.remove0x = void 0;
const ethers_1 = require("ethers");
const remove0x = (v) => (['0X', '0x'].includes(v.slice(0, 2)) ? v.slice(2) : v);
exports.remove0x = remove0x;
const prepend0x = (v) => (['0X', '0x'].includes(v.slice(0, 2)) ? v : `0x${v ? v : '0'}`);
exports.prepend0x = prepend0x;
const evenHex = (v) => {
    if (!ethers_1.utils.isHexString(exports.prepend0x(v))) {
        throw Error(`${v} is not valid hex value`);
    }
    const hex = exports.remove0x(v).replace(/^0+/g, '');
    return `${hex.length % 2 === 0 ? '' : '0'}${hex}`;
};
exports.evenHex = evenHex;
//# sourceMappingURL=helpers.js.map